import {AbstractConditionDescriptionComponent} from "../AbstractConditionDescriptionComponent";

export class ConditionItemSavings extends AbstractConditionDescriptionComponent {
    static instance = () => AbstractConditionDescriptionComponent.instance(ConditionItemSavings, require('./conditionItemSavings.html'));
}